import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChecklist = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "3 3 18 18",
	width: "85%",
	height: "100%",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "m15.548 9-4.558 5.36L9 11.984V12H7.571L11 16l6-7h-1.452zM23 2z" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9zm0 17.003A8 8 0 0 1 3.998 12 8 8 0 0 1 12 3.997c2.122 0 4.158.843 5.659 2.344a8 8 0 0 1 0 11.317A8.002 8.002 0 0 1 12 20.002z" })
	]
});
const ForwardRef = forwardRef(SvgChecklist);
export default ForwardRef;
